// TODO: this could be broken into Vuex modules

import { resortSlug, resortConfig } from './data/resort.config';

export default {
  resortSlug,
  embedEnvironment: null,
  status: 'Loading...',
  resort: {},
  activeMountainArea: null,
  activeMountainAreaName: resortConfig.defaultActiveMountainArea,
  activeMountainSection: resortConfig.activeMountainSection || 'trails',
  additionalText: null, // Used for Tremblant on the uphill tab
  allSections: resortConfig.sections || ['trails', 'lifts', 'attractions', 'maps'],
  activeDashboardSection: resortConfig.defaultActiveDashboardSection || 'Weather',
  attractionsText: resortConfig.attractionsText,
  defaultCMText: resortConfig.defaultCMText || 'centimeters',
  defaultINText: resortConfig.defaultINText || 'inches',
  filterIcons: resortConfig.filterIcons,
  forecastDaysSettings: resortConfig.forecastDays,
  mtnAreaToggles: resortConfig.mtnAreaToggles,
  customIcons: resortConfig.customIcons || [],
  forecast: {},
  mountainAreas: null,
  promoBanner: resortConfig.promoBanner,
  trails: null,
  defaultTrailDifficultyMappings: resortConfig.defaultTrailDifficultyMappings,
  trailDifficultyMappings: resortConfig.trailDifficultyMappings,
  weatherZoneNames: resortConfig.weatherZoneNames || { base: 'Village', mid: 'Mid-Mtn', summit: 'Summit' },
  legalDisclaimer: null,
  lifts: null,
  openStatuses: resortConfig.openStatuses,
  closedStatuses: resortConfig.closedStatuses,
  maps: resortConfig.maps,
  mtnAreaNavSections: resortConfig.mtnAreaNavSections,
  quickLinks: resortConfig.quickLinks,
  quickLinksTitle: resortConfig.quickLinksTitle,
  snow_report: {},
  temperatureUnit: resortConfig.defaultUnit || 'imperial',
  windspeedUnit: resortConfig.defaultUnit || 'imperial',
  snowbaseUnit: resortConfig.defaultUnit || 'imperial',
  trailsOverviewTitle: resortConfig.trailsOverviewTitle,
  summerTrailsOverviewBlocks: resortConfig.summerTrailsOverviewBlocks || [],
  trailsOverviewBlocks: resortConfig.trailsOverviewBlocks,
  trailsOverviewNames: resortConfig.trailsOverviewNames,
  newsinTrailsOverview: resortConfig.newsinTrailsOverview,
  newsAtTop: resortConfig.newsAtTop,
  newsTitle: resortConfig.newsTitle,
  showSnowfallChart: resortConfig.showSnowfallChart || false,
  allSnowfallData: [],
  snowfallChartSettings: resortConfig.snowfallChartSettings || {},
  textOptions: resortConfig.textOptions,
  weather: null,
  activeWeatherZone: null,
  weatherZones: {},
  weatherPrimaryLayoutOption: null,
  weatherSecondaryLayoutOptions: null,
  weatherRoundPrimaryValues: resortConfig.weatherRoundPrimaryValues || false,
  weatherRoundSecondaryValues: resortConfig.weatherRoundSecondaryValues || false,
  weatherZoneDropdownMobileOnly: resortConfig.weatherZoneDropdownMobileOnly || false,
  defaultWeatherZone: resortConfig.defaultWeatherZone || 'base',
  defaultWeatherZones: resortConfig.weatherZones || ['base', 'mid', 'summit'],
  weatherZonesStacked: resortConfig.weatherZonesStacked,
  webcams: [],
  itemsToShow: resortConfig.webcamItemsToShow || 4,
  hooperBreakpoints: resortConfig.hooperBreakpoints || {
    769: { itemsToShow: 5 },
    1200: { itemsToShow: 4 },
    1400: { itemsToShow: 3 },
    1500: { itemsToShow: 2.5 },
    2000: { itemsToShow: 2 },
    2500: { itemsToShow: 1 },
  },
  webcamTitleField: resortConfig.webcamTitleField || 'Title',
  defaultWebcam: null,
};
